import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ReviewPage } from "../../../../components/Learner/ReviewPage";
import { getLastOpenedUrl } from "../../../../utils/lastOpened";

const VocabReviewPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    courseType: stateCourseType = "Drill Vocab",
    score: stateScore = 0,
    currentLevel: stateCurrentLevel = 0,
    questions: stateQuestions = [],
    userAnswers: stateUserAnswers = [],
    fromPage = "/learner/skill-result",
    apiResponse: stateApiResponse = null,
    resultPageState = null,
  } = location.state || {};

  // Set body background to white + add vocab-drill class for CSS overrides
  useEffect(() => {
    document.body.style.background = "#ffffff";
    document.body.style.backgroundImage = "";
    document.body.style.backgroundSize = "";
    document.documentElement.style.background = "#ffffff";
    document.body.classList.add("vocab-drill-review-page");

    return () => {
      document.body.style.background = "";
      document.body.style.backgroundImage = "";
      document.body.style.backgroundSize = "";
      document.documentElement.style.background = "";
      document.body.classList.remove("vocab-drill-review-page");
    };
  }, []);

  const courseType = stateCourseType || "Drill Vocab";
  const score = stateScore;
  const currentLevel = stateCurrentLevel;
  const questions = stateQuestions;
  const userAnswers = stateUserAnswers;
  const apiResponse = stateApiResponse;

  let langCode = 'de';
  if (fromPage?.includes('english')) {
    langCode = 'en';
  } else if (fromPage?.includes('japanese')) {
    langCode = 'ja';
  }

  const handleBack = () => {
    if (
      (fromPage === "/learner/result" || fromPage === "/learner/skill-result") &&
      resultPageState &&
      resultPageState.apiResponse
    ) {
      navigate(fromPage, { state: resultPageState });
    } else {
      const lastOpenedUrl = getLastOpenedUrl();
      if (lastOpenedUrl) {
        navigate(lastOpenedUrl);
      } else if (fromPage && fromPage !== "/learner/language-learning") {
        navigate(fromPage);
      } else {
        navigate("/learner/language-learning");
      }
    }
  };

  return (
    <div className="vocab-drill-review-wrapper w-full">
      <ReviewPage
        courseType={courseType}
        score={score}
        currentLevel={currentLevel}
        questions={questions}
        userAnswers={userAnswers}
        apiResponse={apiResponse}
        langCode={langCode}
        onBack={handleBack}
      />
    </div>
  );
};

export { VocabReviewPage };
export default VocabReviewPage;
